import React from 'react';
import { Link } from 'react-router-dom';
import { events } from '../data/events';

const Events: React.FC = () => {

  return (
    <div className="bg-[#080808] text-white min-h-screen section-padding overflow-hidden">
      <div className="container-responsive">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h1 className="heading-responsive font-bold text-white mb-4 tracking-tight">
            Arrangementer
          </h1>
          <p className="text-responsive max-w-2xl mx-auto" style={{ color: 'rgba(255,255,255,0.45)' }}>
            Nå skjer det
          </p>
        </div>

        {/* Events Grid */}
        <div className="max-w-5xl mx-auto space-y-6 sm:space-y-8">
          {events.map((event) => (
            <Link key={event.id} to={`/events/${event.slug}`} className="block card-glow group cursor-pointer">
              <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 items-start sm:items-center">
                {/* Event Icon */}
                <div className="flex-shrink-0 w-16 h-16 sm:w-20 sm:h-20 text-white opacity-30 group-hover:opacity-60 transition-opacity">
                  {event.iconType === 'running' ? (
                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                  ) : (
                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="9" strokeWidth={1.5} />
                    </svg>
                  )}
                </div>

                {/* Event Details */}
                <div className="flex-1 min-w-0">
                  <h2 className="text-xl sm:text-2xl font-bold text-white mb-2 tracking-tight">
                    {event.name}
                  </h2>
                  <div className="flex flex-col sm:flex-row sm:flex-wrap gap-2 sm:gap-4 mb-3 text-sm sm:text-base" style={{ color: 'rgba(255,255,255,0.4)' }}>
                    <span className="flex items-center gap-2">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                      </svg>
                      {event.date}
                    </span>
                    <span className="flex items-center gap-2">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/>
                      </svg>
                      {event.location}
                    </span>
                  </div>
                  <p className="text-sm sm:text-base leading-relaxed" style={{ color: 'rgba(255,255,255,0.5)' }}>
                    {event.description}
                  </p>
                </div>

                {/* Action Arrow */}
                <div className="flex-shrink-0 w-full sm:w-auto">
                  <span className="btn-primary text-sm py-2 px-6 whitespace-nowrap w-full sm:w-auto inline-flex items-center gap-2">
                    Mer info
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                      <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
                    </svg>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Events;
